import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {routing} from "./statistics.routing";
import {MessagesComponent} from "./messages/messages.component";
import {CompaniesResolver} from "../shared/resolvers/companies.resolver";
import {UsersResolver} from "../shared/resolvers/users.resolver";
import {AuditsResolver} from "../shared/resolvers/audits.resolver";
import {FormsModule} from "@angular/forms";
import {NgSelectModule} from '@ng-select/ng-select';
import {UserPerformanceComponent} from "./userPerformance/userPerformance.component";
import {messageStatsComponent} from "./messagesStatistics/messageStats.component";

@NgModule({
    imports : [
        BrowserModule,
        NgbModule.forRoot(),
        FormsModule,
        NgSelectModule,
        routing
    ],
    declarations : [
        MessagesComponent,
        UserPerformanceComponent,
        messageStatsComponent
    ],
    providers : [
        CompaniesResolver,
        UsersResolver,
        AuditsResolver
    ]
})

export class StatisticsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/statistics/statistics.module.ts